var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"wrapped-static",attrs:{"append-icon":_vm.show ? 'visibility' : 'visibility_off',"type":_vm.show ? 'text' : 'password',"readonly":""},on:{"click:append":function($event){_vm.show = !_vm.show}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }